import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: 'url(#SVGID_1_)',
    },

    st1: {
        fill: '#A324AD',
    },

    st2: {
        fill: '#100239',
    },

    st3: {
        fill: 'url(#SVGID_3_)',
    },

    st4: {
        fill: '#F28C00',
    },

    st5: {
        fill: '#EE7624',
    },

    st6: {
        fill: '#009BE0',
    },

    st7: {
        fill: '#01BFD7',
    },

    st8: {
        fill: '#F9BF01',
    },

    st9: {
        fill: '#76BD22',
    },

    st10: {
        fill: '#00A8E2',
    },

    st11: {
        fill: 'none',
    },

    st12: {
        fill: '#FFFFFF',
    },

    st13: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st14: {
        fontSize: '15px',
        // fontWeight: '600',
    },

}));
